
// If screen is greater then mobile size add class to show cart popout
console.log('localstore '+localStorage.getItem('cartClosed'));
 
if($('body').hasClass('has-cart-items') && $(window).width() > 768 && localStorage.getItem('cartClosed') == 'true' ){
  $('body').addClass('show-cart-summary');
  console.log('cart opened');
} else{
  $('body').removeClass('show-cart-summary');
  console.log('cart closed');
} 

let currentPageURL = window.location.href;
if (window.location.href.indexOf("/apps/w/pay/") > -1) {
  document.querySelector('#shopify-section-header').style.display = 'none';
  document.querySelector('#shopify-section-footer').style.display = 'none';
  document.querySelector('#shopify-section-cart-drawer').style.display = 'none';
  document.querySelector('body').classList.remove("show-cart-summary"); 

  //$(document).load(function() {
  //  $('.payment-form-container .control-label label:contains("Good Through")').html('Expiry Date');
  //}); 

}

function setCookie(cname, cvalue, exhours) {
  var d = new Date(); 
  d.setTime(d.getTime() + (exhours * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}


function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function zapietTimeChangeCall(){
  if(document.querySelector("#storePickupApp #deliveryDatePicker .picker--time")){
    let elems = document.querySelectorAll('#storePickupApp #deliveryDatePicker .picker--time .picker__list .picker__list-item');
    let elemsHasActiveClass = false;


    for (let i = 0; i < elems.length; ++i) {
      if(!elems[i].classList.contains('picker__list-item--disabled')){
        elemsHasActiveClass = true;
      }
    }

    if(elemsHasActiveClass == false){

      let noSlotText = document.querySelector('#zapietNoSlots').getAttribute('data-zapiet-no-slots');

      if(!document.querySelector('#storePickupApp #deliveryDatePicker .picker--time .picker__holder .no-slots-text-item')){
        let theParent = document.querySelector('#storePickupApp #deliveryDatePicker .picker--time .picker__holder');
        let theKid = document.createElement("div");
        theKid.innerHTML = `<li class="picker__list-item no-slots-text-item">${noSlotText}</li>`;
        theParent.appendChild(theKid);
      }

    } else{
      if(document.querySelector('#storePickupApp #deliveryDatePicker .picker--time .picker__holder .no-slots-text-item')){
        document.querySelector('#storePickupApp #deliveryDatePicker .picker--time .picker__holder .no-slots-text-item').remove();
      }
    }
  }
} 
// document.addEventListener("zapietDateChanged", function(event) {
//   setCookie("zapietDeliveryDate", event.detail.date, 1);    
//   zapietTimeChangeCall();
// });

// Sorting for article blog
let bubbleSort = (inputArr) => {
  let len = inputArr.length;
  let swapped;
  do {
      swapped = false;
      for (let i = 0; i < len; i++) {
          if (inputArr[i] > inputArr[i + 1]) {
              let tmp = inputArr[i];
              inputArr[i] = inputArr[i + 1];
              inputArr[i + 1] = tmp;
              swapped = true;
          }
      }
  } while (swapped);
  return inputArr;
};

//Sorting all blogs to show most recent first
let articleArray = [];
if(document.querySelector('.blog-container.master-blog')){
  let articleItems = document.querySelectorAll('[data-article-order]');
  
  articleItems.forEach(function (article, index) {
    let articleOrder = -article.getAttribute('data-article-order');
    article.style.order = articleOrder; 
    articleArray.push(articleOrder);
  });

  articleArray = bubbleSort(articleArray);
  //articleArray.reverse();

  articleArray.forEach(function (item, index) {
    if(index > 6){  
      let itemSelector = '.article[data-article-order="'+Math.abs(item)+'"]';

      document.querySelectorAll(itemSelector).forEach(el => {
        el.style.display = "none";
      });
    }
  });

}

$(window).on('load', function() { 

  var api = new Yotpo.API(yotpo); api.refreshWidgets();
  $('.yotpo-bottomline .write-review-btn-hidden').empty();

  $('.ais-SortBy-select').append('<option style="display: none;" class="ais-SortBy-option" selected value="" disabled>Sort By</option>'); 

  var count = $('.yotpo-bottomline .text-m').text($('.yotpo-bottomline .text-m').text().split(' ')[0]).text();
  var average = $('#yotpo-testimonials .yotpo-bottomline .sr-only').text().split(' ')[0];
  var script = document.createElement('script');
  script.setAttribute('type', 'application/ld+json');
  script.textContent = '{"@context":"http://schema.org","@type":"Product","name":"Planet Organic","aggregateRating":{"@type":"AggregateRating","ratingValue":"'+ average +'","reviewCount":"'+ count +'"}}'
  if ($('#review-script').length) { 
    $('#review-script').append(script);
  }

  if ($('.yotpo-label-container').length && $('.bottom-line-items').length) {
    $('.yotpo-label-container').insertAfter('.bottom-line-items');
    console.log($('.bottom-line-items').html());
  }
});

$( document ).ready(function() {


  // Collection JS
  if ($('div.ais-stats-pagination span:contains("No result")').length > 0) {
    $('div.ais-stats-pagination').hide()
  } 

  if ($(window).width() < 960) {
    $(window).scroll(function() {
    
      if ($(document).scrollTop() > 100) {
        $('.ais-filter-section').addClass('is-sticy');       
      } 
      else {
        $('.ais-filter-section').removeClass('is-sticy');       
      }
    });
  }

  // Footer JS
  $(".accor-wrap .links-column-header").click(function(){
    $(this).parent(".links-column").toggleClass("open");
  });


  // var mobileItems = [];

  // function onReadySortMobileNav() { 
  // $('#ordered-mob-nav li').each(function() { 
  //   mobileItems.push($(this));    
  // });
  
  // mobileItems.sort(function(a,b) { 
  //   return +a.getAttribute('data-nav-order') - +b.getAttribute('data-nav-order');
  //   });
  // }

  // onReadySortMobileNav();

  // console.log(mobileItems);

  Array.from(document.querySelectorAll("ul > li[data-navorder]"))
  .sort(({dataset: {navorder: a}}, {dataset: {navorder: b}}) => a.localeCompare(b)) // To reverse it, use `b.localeCompare(a)`.
  .forEach((item) => item.parentNode.appendChild(item));





  // var customerId = $('.header-wishlist').data('customer-id');

  //  if (customerId)  {
  //     $.get(
  //       'https://advanced-wishlist.hulkapps.com/api/wishlist/lists?customer_id='+ customerId +'&shop=planet-organic-uk.myshopify.com',
  //       function(data) {
  //         if (data[0].total_products > 0) { 
  //           $('.header-wishlist').addClass('has-products');
  //         }
  //       });
  //  }

    // $('#collection-read-more').readmore({ 
      // collapsedHeight: 53,
      // speed: 150,
      // moreLink: '<a class="see-more-collection-excerpt" href="#">See More</a>',
      // lessLink: '<a class="see-more-collection-excerpt less" href="#">See Less</a>'
    // });

  $(window).on('resize', function() {
    var rmjs = $('#collection-read-more');
    var $reader = new Readmore(rmjs, {
      collapsedHeight: 53,
      speed: 150,
      moreLink: '<a class="see-more-collection-excerpt" href="#">See more</a>',
      lessLink: '<a class="see-more-collection-excerpt less" href="#">See less</a>'
    });
  
    if ($(window).width() > 767) {
      $reader.destroy();
    }
  }).trigger('resize');

  $('.ais-SortBy-select').append('<option class="ais-SortBy-option" selected value="" disabled>Sort By</option>'); 

  // Dietary labels click
  $("body").on("click", '.product-guidelines, .dietary-labels-facet-container .dietary-labels__item', function(e) { 
    e.preventDefault();
    $('body').toggleClass('show-dietary-labels');
  });

  // Dietary labels popout close
  $(".dietary-labels__close").on("click", function(e) { 
    e.preventDefault();
    $('body').toggleClass('show-dietary-labels');
  });

  //Search button click on header
  $( ".header-mobile-search" ).click(function(e) {
    e.preventDefault();
    $('.main-top-header__search').toggleClass('show-search');
  }); 

  
  // Header on scroll squeeze
  $(window).scroll(function() {
    var pageHeaderHeight = $('.page-header').outerHeight();
    if ($(document).scrollTop() > pageHeaderHeight + 2) {
        $('.header-container').addClass('fixed-header');
        if ( $('.klarna-top-strip klarna-placement div').length || $('.klarna-top-strip .header-announcement').length ) {
          $('.klarna-top-strip').addClass('fixed-header');
          $('.header-container').addClass('klarna-topstrip-visible');
          if ($('.ais-filter-section.is-sticy').length) {
            $('.ais-filter-section.is-sticy').addClass('topstrip-active');
          }
        }

        $('.algolia-autocomplete').css('position','fixed');
        $('body').addClass('header-is-fixed');
    }
    else {
        $('.header-container').removeClass('fixed-header');
        if ( $('.klarna-top-strip klarna-placement div').length || $('.klarna-top-strip .header-announcement').length  ) {
          $('.klarna-top-strip').removeClass('fixed-header');
          $('.header-container').removeClass('klarna-topstrip-visible');
          $('.ais-filter-section.is-sticy').removeClass('topstrip-active');
        }
        $('.algolia-autocomplete').css('position','absolute');
        $('body').removeClass('show-mobile-nav');
        $('.header-container').removeClass('header-is-fixed');
    }
  });

  $('#feefo-product-review-widgetId').bind('DOMSubtreeModified', function(){
    if( !$('feefowidget-container-onpage-product').is(':empty') ) {
      $('#no-feefo-reviews-text').hide();
    }
  });

  // Accordions js
  $(document).on('click', '.accordion-btn', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var isHidden = $(this).parent().next().toggleClass('hidden').hasClass('hidden');

    $(this).parent().toggleClass('accordion-container--collapsed');     

    $(this).toggleClass('accordion-btn--collapsed', isHidden);

    if (!isHidden) {
      $(this).closest('.accordion-summary').find('.accordion-btn:not(.accordion-btn--collapsed)').not(this).click();
    }
  }); 
    
  $(document).on('click', '.accordion-btn-container', function (e) {
    e.preventDefault();
    $(this).find('.accordion-btn').click();
  });

  $(document).on('click', '.js-close-ais-filter', function (e) {
    e.preventDefault();
    $('.ais-facets-button').trigger('click');
  });

  $(document).on('click', '.ais-facet-mobile-bottom__doneBtn', function (e) {
    e.preventDefault();
    $('.ais-facets-button').trigger('click');
  });

  $(document).on('click', '.ais-facet-mobile-bottom__clearBtn', function (e) {
    e.preventDefault();
    $('.ais-ClearRefinements-button').trigger('click');
  });

  function checkPDP(){
    if ($(window).width() < 768) { 
      $('.product-accordions .accordion-btn').addClass('accordion-btn--collapsed');
      $('.product-accordions .accordion-info-container').addClass('hidden');
      $('.product-accordions .accordion-btn-container').addClass('accordion-container--collapsed');         

      $('.blog-sidebar .accordion-btn').addClass('accordion-btn--collapsed');
      $('.blog-sidebar .accordion-info-container').addClass('hidden');
      $('.blog-sidebar .accordion-btn-container').addClass('accordion-container--collapsed');         
        
    }
  }
  checkPDP();
    
  $( window ).resize(function() {
    checkPDP();
  }); 

  $(document).on('click', 'feefowidget-carousel-summary', function (e) {
  
    if ($(window).width() < 768) { 
      if(!$(e.target).hasClass('feefowidget-read-all-reviews')){
        $('.feefowidget-read-all-reviews')[0].click();
      }
    } 
  });

  $('.ais-facet-item-0 .accordion-btn-container').trigger('click');
  $('.ais-facet-item-1 .accordion-btn-container').trigger('click');


  // Account page
  $(document).on('click', '.js-my-order-btn', function (e) {
    e.preventDefault();
    $('.my-account-sections').addClass('hide-section');
    $('.my-orders-section').removeClass('hide-section');
    $([document.documentElement, document.body]).animate({
      scrollTop: 0
    }, 400);
  }); 


  $(document).on('click', '.js-my-account-btn', function (e) {
    e.preventDefault();
    $('.my-account-sections').addClass('hide-section');
    $('.my-details-section').removeClass('hide-section');
    $([document.documentElement, document.body]).animate({
      scrollTop: 0
    }, 400); 
  });

  $(document).on('click', '.js-back-to-account', function (e) {
    e.preventDefault();
    $('.my-account-sections').addClass('hide-section');
    $('.my-account-section').removeClass('hide-section');
    $([document.documentElement, document.body]).animate({
      scrollTop: 0
    }, 400);  
  }); 

  if($(".template-index .blog-section .row").length){
      $(".template-index .blog-section .row").slick({
        dots: true,
        infinite: false,
        speed: 300, 
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll:1
            }
        }
      ] 
    });
  }
    
  if($('.read-more').length){
    var rmjs = $('.read-more');
    new Readmore(rmjs, {
      collapsedHeight: 110,
      heightMargin: 20
    });
  }

  /* Read more with two different metafield texts */

  const readMoreElement = document.querySelector('.read-more-metafields');

  if (readMoreElement) {
    originalText = readMoreElement.querySelector('.read-more__text').innerText;

    readMoreButton = readMoreElement.querySelector('#ReadMore');
    readLessButton = readMoreElement.querySelector('#ReadLess');
    readMoreText = readMoreElement.querySelector('.read-more__text');
    readLessText = readMoreElement.querySelector('.read-less__text');

    readMoreButton.addEventListener("click", () => {
      readMoreText.classList.remove('hidden');
      readLessText.classList.add('hidden');
      readMoreButton.classList.add('hidden');
      readLessButton.classList.remove('hidden');
    })

    readLessButton.addEventListener("click", () => {
      readMoreText.classList.add('hidden');
      readLessText.classList.remove('hidden');
      readMoreButton.classList.remove('hidden');
      readLessButton.classList.add('hidden');
    })


  }

  var _learnq = _learnq || [];
  var addToCartBtn = document.getElementById("AddToCartBtn");
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click',function (){
    _learnq.push(['track', 'Added to Cart', item]);
  });
  };

});
